import { useTimeout, useUpdateEffect } from '../../hooks';
import { isFunction, __DEV__ } from '../../utils';
import * as React from 'react';
import { getToastStyle } from './toast.utils';
export var Toast = props => {
  var {
    id,
    message,
    onCloseComplete,
    onRequestRemove,
    requestClose = false,
    position = 'bottom',
    duration = 5000
  } = props;
  var [delay, setDelay] = React.useState(duration);
  var toastRef = React.useRef(null);
  useUpdateEffect(() => {
    if (!toastRef.current) {
      onCloseComplete === null || onCloseComplete === void 0 ? void 0 : onCloseComplete();
    }
  }, [toastRef]);
  useUpdateEffect(() => {
    setDelay(duration);
  }, [duration]);
  var onMouseEnter = () => setDelay(null);
  var onMouseLeave = () => setDelay(duration);
  var close = () => {
    if (toastRef.current) {
      onRequestRemove();
    }
  };
  React.useEffect(() => {
    if (toastRef.current && requestClose) {
      onRequestRemove();
    }
  }, [toastRef, requestClose, onRequestRemove]);
  useTimeout(close, delay);
  var style = React.useMemo(() => getToastStyle(position), [position]);
  return /*#__PURE__*/React.createElement("div", {
    className: "tqc-toast",
    style: style,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    ref: toastRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "tqc-toast__inner",
    style: {
      pointerEvents: 'auto'
    }
  }, isFunction(message) ? message({
    id,
    onClose: close
  }) : message));
};
if (__DEV__) {
  Toast.displayName = 'Toast';
}